module.exports = __webpack_public_path__ + "static/dc-sao-paulo-4-f8e3564d49d21b51d640e0de426f40d6.jpg";